import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Node } from '@uncinc/react-drupal-core';
import { getValidEvents, dateCompare } from '../../../../helpers/events';

import './style.scss';

const ViewAgendaUpcoming = ({ entities }) => {
  const maxNumberOfItems = 4;
  let numberOfItems = 0;
  const entitiesGrouped = useMemo(() => {
    let dates = {};
    entities.forEach((entity) => {
      dates = getValidEvents(entity, dates);
    });
    return dates;
  }, [entities]);

  return (
    <div className="ViewAgendaUpcoming">
      <div className="row">
        {Object.keys(entitiesGrouped).sort().map((dateString) => {
          const items = entitiesGrouped[dateString];
          return (
            <>
              {items.sort(dateCompare).map((entity) => {
                const id = entity.getIn(['nid', '0', 'value']);
                const uuid = entity.getIn(['uuid', 0, 'value']);
                const langcode = entity.getIn(['langcode', 0, 'value']);
                const classes = classNames('ViewAgendaUpcoming__item', 'col-12 col-lg-6');
                const delta = entity.get('delta');

                if (numberOfItems >= maxNumberOfItems) {
                  return null;
                }
                numberOfItems = numberOfItems + 1;
                return (
                  <div key={`${uuid}:${langcode}`} className={classes}>
                    <Node
                      id={id}
                      key={`${uuid}:${langcode}`}
                      entity={entity}
                      viewMode="teaser"
                      delta={delta}
                    />
                  </div>
                );
              })}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ViewAgendaUpcoming;
